import { Grid, MenuItem } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import FormSelectTC from "../../../components/Forms/FormSelectTC";

function Algemeen() {
  const { vestigingId } = useFormContext();
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <Grid container spacing={1}>
            <FormAsyncTC
              async={{
                url:
                  "core/voucherdefs/search?fields=id as value, title as label&per_page=50&sort_field=title&vestiging_id=" +
                  vestigingId,
                searchField: "title",
              }}
              key={"voucherdef_id" + vestigingId}
              name={"voucherdef_id"}
              tDefault={"Voucher Definition ID"}
              tKey={"voucherDefs.form.algemeen.label.voucherdef_id"}
            />
            <FormTextTC
              name={"vouchercode"}
              tDefault={"Voucher-Code"}
              tKey={"voucherDefs.form.algemeen.label.vouchercode"}
            />

            <FormTextTC
              name={"accountType"}
              tDefault={"Account code (only for pos account usage)"}
              tKey={"voucherDefs.form.algemeen.label.accountCode"}
            />

            <FormSwitchTC name={"active"} tDefault={"Active"} tKey={"voucherDefs.form.algemeen.label.is_actief"} />
            <FormSelectTC
              name={"type"}
              options={[
                <MenuItem key={"SINGLE_USE"} value={"SINGLE_USE"}>
                  Single-use
                </MenuItem>,
                <MenuItem key={"MULTI_USE"} value={"MULTI_USE"}>
                  Multi-use
                </MenuItem>,
              ]}
              tDefault={"Voucher type"}
              tKey={"voucher.type"}
            />
            <FormTextTC
              name={"total_redemptions_allowed"}
              rules={{
                min: { value: 0, message: <TranslationWrapper tKey={"The minimal value is 1!"} /> },
                pattern: {
                  value: /^[0-9]*$/,
                  message: <TranslationWrapper tKey={"Only whole numbers are allowed!"} />,
                },
              }}
              tDefault={"How many times may the voucher be used? (empty is unlimited)"}
              tKey={"voucher.total_redemptions_allowed"}
            />
            <FormSwitchTC name={"final"} tDefault={"final"} tKey={"voucherDefs.form.algemeen.label.is_final"} />
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Algemeen;
